// Navigation service for programmatic navigation outside of React components
class NavigationService {
  private navigateFunction: ((path: string, options?: { replace?: boolean }) => void) | null = null;

  setNavigate(navigate: (path: string, options?: { replace?: boolean }) => void) {
    this.navigateFunction = navigate;
  }

  redirectToLogin() {
    if (this.navigateFunction) {
      this.navigateFunction('/login', { replace: true });
    } else {
      // Fallback to window.location if navigate is not available
      window.location.href = '/login';
    }
  }

  redirectToHome() {
    if (this.navigateFunction) {
      this.navigateFunction('/', { replace: true });
    } else {
      // Fallback to window.location if navigate is not available
      window.location.href = '/';
    }
  }
}

export const navigationService = new NavigationService(); 